import { axisFromCode, type Axis } from '../lib/axis';
import { getDimension, useAllData } from '../data/loaders';

interface Props {
  code: string;
  className?: string;
  /** Override the hover-title (by default: the dimension's Serbian title). */
  title?: string;
}

/**
 * Small inline badge showing a dimension code (OP-09, SN-P5, etc.)
 * with axis coloring. Hover reveals the dimension's Serbian title.
 * Used in cards, pills, breadcrumbs.
 */
export default function AxisBadge({ code, className = '', title }: Props) {
  const axis: Axis = axisFromCode(code);
  const data = useAllData();
  const dim = getDimension(data, code);
  const hoverTitle = title ?? dim?.title ?? code;
  return (
    <span className={`axis-badge axis-badge-${axis} ${className}`} title={hoverTitle}>
      {code}
    </span>
  );
}
